<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        Existing Contract Request
    </div>
</div>

<div class="nova__dialog__content" mat-dialog-content>
    <div class="container">
        <div>
            <div class="app-dialog-note-container">
                    <div class="app-dialog-note-table">
                        <div class="app-dialog-note-row">
                            <div class="app-dialog-note-cell app-width-36px">
                                <div class="app-dialog-note-icon">
                                    <img src="assets/images/svg/surprise-regular.svg" class="unable-to-review-img" alt="Unable to Review + Send" title="Unable to Review + Send" />
                                </div>
                            </div>
                            <div class="app-dialog-note-cell app-v-center">
                                <span class="app-dialog-note-text">There's an existing contract request associated with this candidate and facility. </span>
                                <a class="nova__link" (click)="viewExistingContractRequests()">View existing requests</a>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="item">
                <div>
                    <span class="unable-to-review-message">
                        Please select a reason for creating this duplicate contract request.
                    </span>
                </div>
                <div>
                    <mat-form-field class="item-container-field">
                        <mat-label *ngIf="selectedReason!=='review-and-send' && selectedReason!=='view-existing-requests'">Select a reason</mat-label>
                        <mat-select [(value)]="selectedReason" >
                            <mat-option *ngFor="let reason of reasons" [value]="reason.key" >{{reason.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="item" *ngIf="selectedReason==='view-existing-requests'">
                <div>
                    <span class="unable-to-review-message">
                        To avoid duplicates, please find and edit the existing contract request instead.
                    </span>
                </div>
            </div>
        </div>
    </div>
    <mat-dialog-actions class="nova__dialog__content__actions">
        <button mat-raised-button color="primary" *ngIf="selectedReason!=='review-and-send' && selectedReason!=='view-existing-requests'" [disabled]="true">NEXT</button>
        <button (click)="continueToReviewAndSend()" mat-raised-button color="primary" *ngIf="selectedReason==='review-and-send'">CONTINUE TO REVIEW + SEND</button>
        <button (click)="viewExistingContractRequests()" mat-raised-button color="primary" *ngIf="selectedReason==='view-existing-requests'">VIEW EXISTING REQUESTS</button>
        <button (click)="close()" [disabled]="isLoading" mat-raised-button color="default">CANCEL</button>
    </mat-dialog-actions>
</div>